import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import VideoPlaylist from '../../video-playlist';
import { liveBlogTracking } from '../tracking';

import {
  CardTypes,
} from '../utils';

type VideoPlaceholderProps = {
  video: CardTypes;
  position: string;
};

const {
  nbc: {
    dataLayer: {
      leadIsFast = false,
    } = {},
  } = {},
} = window;

export default function VideoPlaceholder({ video, position }: VideoPlaceholderProps) {
  const {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    leadThumbnail = '',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    videos: [{
      title,
      poster: mpxThumb,
      isFast,
    }],
  } = video;

  const hideFast = 1 === Number(isFast) && leadIsFast;

  const vidPlaceholderClass = hideFast ? '' : 'video-placeholder';

  const hideShare = true;

  const thumbnail = leadThumbnail || mpxThumb;

  const [showVideo, setShowVideo] = useState(false);

  const randomVideoClass = `lbvideo-${Math.floor(Math.random() * 9000000000) + 1000000000}`;

  const onClick = () => {
    if (! hideFast) {
      setShowVideo(true);
    }
  };

  useEffect(() => {
    if (showVideo) {
      liveBlogTracking('play', 'video click', randomVideoClass);
    }
  }, [showVideo]);

  return (
    <div
      className={
        `liveblog-card__${position}media ${position}video ${showVideo ?
          '' : vidPlaceholderClass} ${randomVideoClass}`
      }
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      {
        ! showVideo ?
          <img
            src={thumbnail}
            alt={title}
          />
          :
          <div className="videoContainer">
            <VideoPlaylist
              accountId={''}
              autoplay
              placeholder
              brand={''}
              host={''}
              twitter={''}
              callLetters={''}
              station={''}
              videos={[]}
              excludeEndCard
              hideShare={hideShare}
              {...video}
            />
          </div>
      }
    </div>
  );
}

VideoPlaceholder.propTypes = {
  video: PropTypes.objectOf(PropTypes.object).isRequired,
  position: PropTypes.oneOf(['lead', 'embed']),
};

VideoPlaceholder.defaultProps = {
  position: 'embed',
};
